<template>
  <footer class="app-footer" :class="{'with-sidebar': withSidebar}">
    <div class="footer-content">
      <div class="footer-links">
        <router-link to="/terms-of-use" target="_blank" class="footer-link">
          {{ $t('legal.titleTermsOfUse') }}
        </router-link>
        <span class="separator">|</span>
        <a href="https://www.ramps.jp/privacy" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ $t('legal.titlePrivacyPolicy') }}
        </a>
        <span class="separator">|</span>
        <a href="https://ramps.notion.site/2b8de921aa5a805aa1dfddf6bb6d6e5c" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ $t('common.contact') }}
        </a>
      </div>
      <div class="footer-copyright">
        {{ $t('common.copyright') }}
      </div>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  withSidebar: {
    type: Boolean,
    default: true
  }
});
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: #fafafa;
  color: #666666;
  padding: 32px 20px;
  margin-left: 0;

  &.with-sidebar {
    margin-left: 250px;
  }

  @media (max-width: 991.98px) {
    &.with-sidebar {
      margin-left: 0;
    }
  }
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.footer-links {
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 767.98px) {
    flex-direction: column;
    gap: 12px;
  }
}

.footer-link {
  color: #306fc9;
  text-decoration: underline;
  font-size: 14px;
  transition: color 0.2s;

  &:hover {
    color: #5c9fd8;
    text-decoration: underline;
  }
}

.separator {
  color: #bccddb;
  margin: 0 4px;

  @media (max-width: 767.98px) {
    display: none;
  }
}

.footer-copyright {
  color: #222222;
  font-size: 14px;
  margin-top: 8px;
}
</style>
